import { format, parseISO, differenceInDays, formatDistanceToNow as dfFormatDistanceToNow } from 'date-fns';

export const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, 'MMM dd, yyyy');
  } catch (error) {
    return dateString;
  }
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, 'MMM dd, yyyy HH:mm');
  } catch (error) {
    return dateString;
  }
};

export const getDaysRemaining = (endDate) => {
  if (!endDate) return 0;
  try {
    const end = typeof endDate === 'string' ? parseISO(endDate) : endDate;
    return differenceInDays(end, new Date());
  } catch (error) {
    return 0;
  }
};

export const getCampaignStatus = (startDate, endDate) => {
  const now = new Date();
  const start = typeof startDate === 'string' ? parseISO(startDate) : startDate;
  const end = typeof endDate === 'string' ? parseISO(endDate) : endDate;
  if (now < start) return 'scheduled';
  if (now > end) return 'completed';
  return 'active';
};

export const formatDistanceToNow = (input) => {
  if (!input) return '';
  try {
    const date = typeof input === 'string' ? parseISO(input) : input;
    return dfFormatDistanceToNow(date, { addSuffix: false });
  } catch (error) {
    return '';
  }
};

export const toApiDateTime = (dateString) => {
  if (!dateString) return null;
  try {
    const date = parseISO(dateString);
    if (Number.isNaN(date.getTime())) return null;
    return date.toISOString();
  } catch {
    return null;
  }
};

export const toDateInputValue = (dateTimeString) => {
  if (!dateTimeString) return '';
  try {
    return format(parseISO(dateTimeString), 'yyyy-MM-dd');
  } catch {
    return String(dateTimeString).slice(0, 10);
  }
};